export {};

$(init);

NLMK.initSliderQuotes = init;

function init() {
    const $sliders = $('.js-slider-quotes');

    if ($sliders.length) {
        require.ensure(['./module'], () => {
            const { eachSlider } = require('./module');

            $sliders.each(eachSlider);
        }, 'slider-quotes');
    }
}



// WEBPACK FOOTER //
// ./js/main/module/sliders/quotes/index.js